import { render, staticRenderFns } from "./ViewVoucherPage.vue?vue&type=template&id=1367cba8&scoped=true&"
import script from "./ViewVoucherPage.vue?vue&type=script&lang=js&"
export * from "./ViewVoucherPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewVoucherPage.vue?vue&type=style&index=0&id=1367cba8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1367cba8",
  null
  
)

export default component.exports